var React = require('react');

function FlagEsMd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0-1h256v173H0","fill":"#C60B1E","key":0}),React.createElement("path",{"d":"M27 57.573h41.047l-32.64 23.726L47.771 42.25l12.364 39.049M55.458 105.708h41.047l-32.64 23.726L76.23 90.385l12.364 39.049M80.458 57.573h41.047l-32.64 23.726L101.23 42.25l12.364 39.049M108.916 105.708h41.047l-32.64 23.726 12.364-39.049 12.364 39.049M133.916 57.573h41.047l-32.64 23.726 12.364-39.049 12.364 39.049M162.374 105.708h41.047l-32.64 23.726 12.364-39.049 12.364 39.049M187.374 57.573h41.047l-32.64 23.726 12.364-39.049 12.364 39.049","fill":"#fff","key":1}),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"d":"M0 0h256v172H0V0z","fill":"#fff"})))]);
}

FlagEsMd.defaultProps = {"fill":"none","viewBox":"0 0 256 172"};

module.exports = FlagEsMd;

FlagEsMd.default = FlagEsMd;
